export default [
  {
    portalGroup: 'collab.public',
    path: '/project/update/:id',
    name: 'ProjectUpdate',
    component: () => import('./PgProjectUpdate')
  }
]
